<template>
  <div class="container">
    <img
      src="../../assets/img/pic_register2.png"
      alt
      class="state-img"
    />
    <div class="box">
      <div class="affirm">绑定银行卡需要对银行预留手机号进行短信确认</div>
      <div class="yardage">
        <span class="code">接收验证码</span>
        <span class="phone">{{mobilePhone}}</span>
      </div>
      <div class="verification">
        <span class="code">验证码</span>
        <van-field
          v-model="value"
          type="number"
          border
          clearable
          maxlength="6"
          placeholder="请输入验证码"
          :formatter="formatter"
        />
        <van-button
          class="send hairline"
          plain
          color="#FF3838"
          @click="getBindingSmsCode"
          :disabled="disabled"
        >{{verifyCode}}</van-button>
      </div>
      <div
        class="tips"
        style="visibility:hidden"
      >
        <img
          src="../../assets/img/send.png"
          alt
        />验证码已发送，可能会有延迟，2分钟内有效
      </div>
    </div>
    <div class="agreement">
      <van-checkbox
        v-model="checked"
        shape="square"
        icon-size="15px"
        style="align-items: inherit;justify-content: center"
      >我已阅读并同意<span @click.stop="goToAgreement(0)">《平安数字用户服务协议》</span><br /><span @click.stop="goToAgreement(1)">《平安银行电子商务支付结算服务协议》</span></van-checkbox>
    </div>
    <van-button
      class="btn"
      text="下一步"
      :disabled="value.length!=6 || showCodeError"
      @click="gotoNext"
    />
    <div
      class="codeError"
      v-if="showCodeError"
    >输入验证码错误次数太多，{{minute}}分钟后再操作</div>
  </div>
</template>
<script>
import { getBindingSmsCode, putBindingSmsCode, getOperateFailMsg } from "@/api/join";

export default {
  data() {
    return {
      verifyCode: "发送验证码",
      disabled: false,
      value: "", //验证码
      show: false, //数字键盘
      obj: {},
      mobilePhone: "", //手机号
      minute: "",
      showCodeError: false,
      sentCode: false, //true为发送过验证码
      checked: false
    };
  },
  mounted() {
    this.obj = JSON.parse(this.$route.params.obj);
    this.mobilePhone = this.obj.mobilePhone;
    this.getOperateFailMsg();
  },
  methods: {
    goToAgreement(type) {
      this.$router.push({
        path: "/agreement",
        query: {
          type,
        },
      });
    },
    formatter(value) {
      return value.replace(/[^\d]/g, "");
    },
    sendCodeError(i) {
      i = i - 1;
      this.minute = parseInt(i / 60);
      if (i == 0) {
        this.showCodeError = false;
        this.disabled = false;
        return;
      }
      setTimeout(() => {
        this.sendCodeError(i);
      }, 1000);
    },
    sendCode(i) {
      //发送验证码
      i = i - 1;
      this.verifyCode = i + "S";
      if (i == 0) {
        this.verifyCode = "重新发送";
        this.disabled = false;
        return;
      }
      setTimeout(() => {
        this.sendCode(i);
      }, 1000);
    },
    getBindingSmsCode() {
      getBindingSmsCode(this.obj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.disabled = true;
          this.sentCode = true;
          this.sendCode(60);
        }
      });
    },
    putBindingSmsCode() {
      let obj = this.obj;
      obj.messageCode = this.value;
      putBindingSmsCode(obj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$router.push({
            name: "successfully",
            path: "/successfully",
            params: {
              message: res.appStatus.message,
              code: res.appStatus.errorCode,
            },
          });
        } else if (res.appStatus.errorCode == 4224) {
          this.getOperateFailMsg();
        }
      });
    },
    getOperateFailMsg() {
      getOperateFailMsg({
        userTpye: "1", //会员角色 1:买家、2:卖家、3:厂家、4:选菜师、5:菜老板助手 6城市合伙人
        verifyType: "2", // 认证类型 1.提现 2.绑卡
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          if (res.content.errNum >= 3) {
            this.disabled = true;
            this.showCodeError = true;
            this.sendCodeError(res.content.tryTime);
          }
        }
      });
    },
    gotoNext() {
      if (!this.sentCode) {
        this.$toast("您未发送验证码");
        return;
      }
      if (!this.checked) {
        this.$toast("请先勾选协议");
        return;
      }
      this.putBindingSmsCode();
    },
  },
};
</script>
<style lang="scss" scoped>
.state-img {
  margin: 15px auto 20px;
  width: 271px;
  height: 55px;
}
.box {
  padding: 15px 12px 0;
  background: #fff;
  .affirm {
    font-size: 13px;
    color: #999;
  }
  .yardage {
    font-size: 17px;
    padding: 17px 0 13px;
    .phone {
      font-size: 20px;
      font-weight: bold;
      color: #333333;
    }
  }
  .verification {
    display: flex;
    align-items: center;
    height: 60px;
  }
  .code {
    display: inline-block;
    font-size: 16px;
    width: 90px;
    color: #333333;
  }
  .van-field {
    width: 150px;
    padding-left: 0;
    font-size: 16px;
  }
  .send {
    width: 100px;
    height: 40px;
    padding: 0;
    margin-left: 8px;
    font-size: 15px;
    border-radius: 10px;
  }
  .van-button--disabled {
    color: #999999 !important;
    border-color: #999999 !important;
    background-color: #ffffff !important;
    opacity: 1;
  }
  .tips {
    height: 53px;
    line-height: 53px;
    font-size: 12px;
    color: #666666;
    display: flex;
    align-items: center;
    img {
      width: 13px;
      height: 13px;
      margin-right: 5px;
    }
  }
}
.agreement {
  margin-top: 37px;
  font-size: 12px;
  color: #999999;
  text-align: center;
  span {
    color: #2979ff;
  }
}
.btn {
  width: 351px;
  height: 40px;
  font-size: 16px;
  margin: 10px 12px 0;
  background-color: #50BE4C;
  border-radius: 5px;
  font-size: 17px;
  color: #ffffff;
  border-radius: 50px;
}
.van-button--disabled {
  color: #ffffff;
  background-color: #cccccc;
  opacity: 1;
}
.codeError {
  margin: 12px 16px 0;
  font-size: 15px;
  color: #666666;
}
</style>